import { Link, useLocation } from "react-router-dom";
import { FaLaptopCode, FaPaperPlane } from "react-icons/fa";
import { BsBookHalf } from "react-icons/bs";

const MenuMobileHorizontal = () => {
  const location = useLocation();

  return (
    <div className="bg-[#1f2d32] max-h-16 h-full fixed bottom-0 left-0 right-0 z-50 lg:hidden">
      <ul className="flex text-white h-full">
        <li className="flex-1 flex items-center">
          <Link
            to={"/"}
            className={`${
              location.pathname === "/"
                ? "text-[#c3e88d] dark:text-blue-500"
                : "text-white"
            } w-full flex flex-col items-center`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-6 h-6"
            >
              <path d="M11.47 3.84a.75.75 0 011.06 0l8.69 8.69a.75.75 0 101.06-1.06l-8.689-8.69a2.25 2.25 0 00-3.182 0l-8.69 8.69a.75.75 0 001.061 1.06l8.69-8.69z" />
              <path d="M12 5.432l8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 01-.75-.75v-4.5a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75V21a.75.75 0 01-.75.75H5.625a1.875 1.875 0 01-1.875-1.875v-6.198a2.29 2.29 0 00.091-.086L12 5.43z" />
            </svg>
            <span className="text-sm sm:text-base">Accueil</span>
          </Link>
        </li>

        <li className="flex-1 flex items-center">
          <Link
            to={"/projets"}
            className={`${
              location.pathname === "/projets"
                ? "text-[#82aac1] dark:text-blue-500"
                : "text-white"
            } w-full flex flex-col items-center`}
          >
            <FaLaptopCode className="w-6 h-6" />
            <span className="text-sm sm:text-base">Projets</span>
          </Link>
        </li>

        <li className="flex-1 flex items-center">
          <Link
            to={"/blog"}
            className={`${
              location.pathname === "/blog"
                ? "text-[#ffcb6b] dark:text-blue-500"
                : "text-white"
            } w-full flex flex-col items-center`}
          >
            <FaLaptopCode className="w-6 h-6" />
            <span className="text-sm sm:text-base">Blog</span>
          </Link>
        </li>

        <li className="flex-1 flex items-center">
          <Link
            to={"/contact"}
            className={`${
              location.pathname === "/contact"
                ? "text-[#f77669] dark:text-blue-500"
                : "text-white"
            } w-full flex flex-col items-center`}
          >
            <FaPaperPlane className="w-6 h-6" />
            <span className="text-sm sm:text-base">Contact</span>
          </Link>
        </li>

        <li className="flex-1 flex items-center">
          <Link
            to={"/livre-dor"}
            className={`${
              location.pathname === "/livre-dor"
                ? "text-[#c792cf] dark:text-blue-500"
                : "text-white"
            } w-full flex flex-col items-center`}
          >
            <BsBookHalf className="w-6 h-6" />
            <span className="text-sm sm:text-base">Livre d'or</span>
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default MenuMobileHorizontal;
